import React from 'react'
import FontIcon from 'material-ui/FontIcon'

class Transactions extends React.Component {
  constructor(props) {
    super(props)
  }
  renderTranstactions() {
    const { order } = this.props
    const styles = {
      h3: {
        fontSize: '16px',
        textTransform: 'uppercase',
        fontWeight: '700'
      },
      icon:{
        fontSize: '16px',
        marginBottom: '5px',
      },
      hideText: {
        display: 'none',
      },
      itemDiv: {
        lineHeight: '18px',
        marginBottom: '10px',

      },
      text: {
        fontSize: '15px',
        fontWeight: '600',
      }
    };
    if (order && order.shipping && order.shipping.length) {
      return order.transactions.map((trans, i) =>
        <div key={`${i}`}>
          <div href="#" className="list-group-item flex-column align-items-start">
            <div className="d-flex  w-100 justify-content-between">
              <div className="row">
                <p className="col" style={styles.h3}>{trans.processor_type || ''}</p>
                <div className="col">
                  {(trans.type == 'payment' 
                    ? <FontIcon style={styles.icon} className="fa fa-plus"/> 
                    : null) 
                  || (trans.type == 'redemption' 
                    ? <FontIcon style={styles.icon} className="fa fa-minus"/> 
                    : null)}
                </div>
                <div className="col">
                  <span style={styles.text}>${trans.amount || ''}</span>
                </div>
              </div>
              <div 
                style={(new Date(trans.created_at).toLocaleString()) == '' 
                ? styles.hideText 
                : styles.itemDiv}>
                <span style={styles.text}>{new Date(trans.created_at).toLocaleString() || ''}</span>
              </div>
            </div>
            <div className="row">
              <p className="col-md-12 col-lg-6" style={trans.last4 == '' ? styles.hideText : styles.itemDiv}>
                Credit Card: . . . . 
                <span style={styles.text}>{trans.last4 || ''}</span></p>
              <p className="col-md-12 col-lg-6" style={trans.transaction_id == '' ? styles.hideText : styles.itemDiv}>
                TRX:&nbsp;
                {(trans.processor_type == 'braintree' || trans.processor_type == 'stripe')
                ? <a target="_blank" href={trans.transaction_url} style={styles.text}>
                  <span style={styles.text}>{trans.transaction_id || ''}</span>
                </a>
                : <span style={styles.text}>{trans.transaction_id || ''}</span> }
              </p>
            </div>
            <div className="row">
              <p className="col-md-12 col-lg-6" style={trans.card_id == '' ? styles.hideText : styles.itemDiv}>
                Card Id:&nbsp;
                <span style={styles.text}>{trans.card_id || ''}</span>
              </p>
              <p className="col-md-12 col-lg-6" style={(trans.giftcard_code == '' || trans.giftcard_code == null) ? styles.hideText : styles.itemDiv}>
                Gift Card Code:&nbsp;
                <span style={styles.text}>{trans.giftcard_code || ''}</span>
              </p>
            </div>
            <div className="row">
              <p className="col-md-12 col-lg-6" style={trans.customer_id == '' ? styles.hideText : styles.itemDiv}>
                Customer Id:&nbsp;<span style={styles.text}>{trans.customer_id || ''}</span></p>
              <p className="col-md-12 col-lg-6" style={trans.payment_method == '' ? styles.hideText : styles.itemDiv}>
                Payment Method:&nbsp;<span style={styles.text}>{trans.payment_method || ''}</span>
              </p>
            </div>
            <p style={trans.response == '' ? styles.hideText : styles.itemDiv}>
              Response:&nbsp;
              <span style={styles.text}>{trans.response || ''}</span>
            </p>
          </div>
        </div>
      )
    }
  }
  render() {
    return (
      <div>
        <h2>Transactions</h2>
        <div style={{ paddingLeft:'15px', paddingBottom: '20px', paddingRight:'15px' }} className="list-group">
          {this.renderTranstactions()}
        </div>
      </div>)
  }

}
export default Transactions;


// WEBPACK FOOTER //
// ./src/components/orders/Common/Transactions.js